import { CerFormAdapter } from "@cer/cer-form/cer-form-adapter";
import { CerFormView } from "@cer/cer-form/cer-form-view";

export class BankAccountTransactionSourceForm extends CerFormAdapter {

  public override view(): CerFormView {

    return new CerFormView({
      viewMetadata: {
        name: 'bilag-transaktion-kilder', dataApiName: 'BankAccountTransactionSource', text: 'Kilder', textSingular: 'Kilde',
        primaryKey: 'id', allowEdit: true, allowCreate: false, allowDelete: false, baseFields: ['id', 'history']
      },
      fieldMetadata: [
        { name: 'name', text: 'Kildenavn' },
        { name: 'sourceGroup', text: 'Gruppe', foreignKeyTableName: 'BankAccountTransactionSourceGroup' },
        { name: 'voucherMessageChannel', text: 'Bilagskanal', tooltipText: 'Kanal der er tilknyttet ved bilag', foreignKeyTableName: "VoucherMessageChannel" },
        { name: 'offsetAmount', text: 'Vend fortegn', tooltipText: 'Vend fortegn for beløb', format: 'CheckBox' }
      ]
    });

  }
}
